 <template>
  <div
    class="
      border border-gray-500
      hover:border-STorange
      font-QuestrialFont
      text-lg text-gray-500
      px-3
      py-2
      cursor-pointer
      shadow-md
    "
    :class="featuredStyling"
    @click="openLink"
  >
    <div class="flex">
      <div class="min-w-0">
        <p class="truncate text-sm xl:text-md">
          {{ header }}
        </p>
        <p class="text-xs 2xl:text-sm">{{ date | formatDate }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import "../../../utils/filters";

export default {
  name: "PressRelease",

  props: {
    featured: Boolean,
    header: String,
    date: String,
    identifier: String,
    previewMode: Boolean,
  },

  computed: {
    featuredStyling() {
      return this.featured ? "bg-orange-100" : "";
    },
  },

  methods: {
    openLink() {
      if (!this.previewMode) {
        this.$router.push({
          name: "PressReleasePage",
          params: { id: this.identifier },
        });
      }
    },
  },
};
</script>